import { ref, watch } from 'vue'

// Estado reactivo global del tema
const getInitialTheme = () => {
  const savedTheme = localStorage.getItem('app-theme')
  const validThemes = ['blue', 'light', 'dark']
  
  if (savedTheme && validThemes.includes(savedTheme)) {
    return savedTheme
  }
  return 'blue' // tema por defecto
}

const currentTheme = ref(getInitialTheme())
let currentThemeLink = null // Referencia al elemento link actual

export function useTheme() {
  const cambiarFavicon = (theme) => {
    // Determinar qué favicon usar según el tema
    let faviconPath
    if (theme === 'blue') {
      faviconPath = './icono_solido1.png'
    } else {
      faviconPath = './icono_solido2.png'
    }
    
    // Buscar el elemento favicon existente
    let faviconLink = document.querySelector('link[rel="icon"]') || 
                     document.querySelector('link[rel="shortcut icon"]')
    
    if (faviconLink) {
      // Actualizar el href del favicon existente
      faviconLink.href = faviconPath
    } else {
      // Crear nuevo elemento favicon si no existe
      faviconLink = document.createElement('link')
      faviconLink.rel = 'icon'
      faviconLink.type = 'image/png'
      faviconLink.href = faviconPath
      document.head.appendChild(faviconLink)
    }
    
    console.log(`Favicon cambiado a: ${faviconPath}`)
  }

  const cargarArchivoCSS = (theme) => {
    // Validar que theme sea un string válido
    if (typeof theme !== 'string' || !theme) {
      console.warn('Tema inválido:', theme)
      theme = 'blue' // tema por defecto
    }
    
    // Remover el archivo CSS del tema anterior
    if (currentThemeLink) {
      currentThemeLink.remove()
      currentThemeLink = null
    }
    
    // Crear nuevo elemento link para el tema
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.type = 'text/css'
    // Usar ruta relativa que funcione con el servidor de desarrollo de Vue
    link.href = `./themes/theme-${theme}.css`
    link.id = `theme-${theme}`
    // Identificar como tema personalizado para mayor prioridad
    link.setAttribute('data-theme', 'custom')
    
    // Insertar después de Bootstrap para que tenga mayor prioridad
    // Buscar el último elemento de Bootstrap o insertar al final
    const bootstrapLinks = document.querySelectorAll('link[href*="bootstrap"]')
    if (bootstrapLinks.length > 0) {
      const lastBootstrapLink = bootstrapLinks[bootstrapLinks.length - 1]
      lastBootstrapLink.parentNode.insertBefore(link, lastBootstrapLink.nextSibling)
    } else {
      document.head.appendChild(link)
    }
    currentThemeLink = link
    
    // También agregar clase al body para compatibilidad
    document.body.classList.remove('theme-blue', 'theme-light', 'theme-dark')
    document.body.classList.add(`theme-${theme}`)
    
    // Cambiar el favicon según el tema
    cambiarFavicon(theme)
    
    console.log(`Tema ${theme} cargado:`, link.href)
  }
  
  const cambiarTema = (theme) => {
    currentTheme.value = theme
    localStorage.setItem('app-theme', theme)
    cargarArchivoCSS(theme)
  }
  
  // Observar cambios en el tema
  watch(currentTheme, (newTheme) => {
    cargarArchivoCSS(newTheme)
  })

  // Cargar tema inicial
  cargarArchivoCSS(currentTheme.value)
  // Cambiar favicon inicial
  cambiarFavicon(currentTheme.value)

  return {
    currentTheme,
    cambiarTema,
    cargarArchivoCSS
  }
}